import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class ServiceCategoryExistsRequestQuery extends AbstractGraphqlRequest<boolean> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query serviceCategoryExists(
        $payload: ServiceCategoryRequestPayloadInput!
      ) {
        serviceCategoryExists(payload: $payload)
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    if (typeof data.serviceCategoryExists === 'boolean') {
      return data.serviceCategoryExists;
    }

    return false;
  }
}
